import React from "react";
import {
    List as AntList,
    Typography,
    Card,
    Row,
    Col,
    Button,
    Tabs,
    Icon,
    Input,
    // Popconfirm,
    Modal,
    message
} from "antd";
import PropTypes from "prop-types";
import cx from "classnames";
import { DOCUMENT_CURRENT_STATUS } from "constants/enums";
import moment from "moment";
import UploadCompanyDoc from "forms/upload-company-doc-form";
const ListItem = AntList.Item;
const { Paragraph } = Typography;
const TabPane = Tabs.TabPane;
import DocumentService from "services/documents-service";
import "styles/document-review.css";

class CompanyDocumentViewList extends React.PureComponent {
    fileUpload = false;

    state = {
        fileName: null,
        isClicked: null,
        selectedTab: "uploaded",
        showUploadModal: false
    };

    onTabChange = (e) => {
        this.setState({
            selectedTab: e,
        });
    }

    get _areFilesLoading() {
        return this.props.filesStatus !== "FETCHED";
    }

    getStatus = status => {
        if (status === DOCUMENT_CURRENT_STATUS.get("Pending Approval")) {
            return <div className={"pending-approval"}>Pending Approval</div>;
        }
        if (status === DOCUMENT_CURRENT_STATUS.get("Rejected")) {
            return <div className={"rejected-doc"}>Rejected</div>;
        }
        if (status === DOCUMENT_CURRENT_STATUS.get("Verified")) {
            return <div className={"approved-doc"}>Approved</div>;
        }
        if (status === DOCUMENT_CURRENT_STATUS.get("Requested")) {
            return <div className={"requested-doc"}>Requested</div>;
        }
    };

    onFileNameEdit = (file, value) => {
        this.setState(
            {
                fileName: value
            },
            () => {
                this.props.changeName(
                    file.set("file_name", this.state.fileName)
                );
            }
        );
    };

    docFilter = (file) => {
        if (this.state.filter) {
            return file && file.file_name && file.file_name.toLocaleLowerCase().includes(this.state.filter.toLocaleLowerCase());
        }
        return true;
    }

    onDocSearch = event => {
        this.setState({
            filter: event.target.value
        });
    }

    getTitle = file => {
        return (
            <React.Fragment>
                <Row>
                    <Col
                        span={24}
                        className={
                            "d-flex flex-direction-row justify-content-space-between"
                        }>
                        <div
                            style={{
                                textOverflow: "ellipsis",
                                fontSize: 12,
                                fontWeight: 600,
                                color: "#000000"
                            }}>
                            <Paragraph
                                editable={{
                                    onChange: this.onFileNameEdit.bind(
                                        null,
                                        file
                                    )
                                }}>
                                {file.file_name}
                            </Paragraph>
                        </div>
                        {/* <div style={{
                            color: "#eb5757",
                            background: "transparent"
                        }}>
                            <Button type={"link"} icon={"download"} target={"_blank"} href={file.file} />
                            <Popconfirm
                                title="Are you sure delete this file?"
                                onConfirm={
                                    () => this.props.deleteRequestedDocument(file.id,file)
                                }
                                okText="Yes"
                                cancelText="No"
                            >
                                <a><Icon style={{
                                    cursor: "pointer"
                                }} type={"delete"} /></a>
                            </Popconfirm>
                        </div> */}
                    </Col>
                    <Col span={15}>
                        <div className={"doc-date"}>
                            {file &&
                                moment(file.modified_date).format(
                                    "MMM Do YYYY,    h:mm a"
                                )}
                        </div>
                    </Col>

                    <Col span={9}>{this.getStatus(file.document_status)}</Col>
                    {
                        file.document_status === DOCUMENT_CURRENT_STATUS.get("Rejected") && file.remarks && file.remarks !== " " ?
                            (<Col className={"doc-date"} span={24} style={{
                                color: "#eb5757"
                            }}>
                                {file.remarks}
                            </Col>) : null
                    }
                </Row>
            </React.Fragment>
        );
    };

    getRequestedDocTitle = (doc) => {

        return (
            <React.Fragment>
                <Col span={24} className={
                    "d-flex flex-direction-row justify-content-space-between"
                }>
                    <div
                        style={{
                            textOverflow: "ellipsis",
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#000000"
                        }}
                    >
                        {doc.document && doc.document.document_name}
                    </div>
                    <div style={{
                        color: "#eb5757",
                        background: "transparent",
                        cursor: "pointer"
                    }}>
                        <Icon type={"delete"} onClick={() => this.props.deleteRequestedDocument(doc.id, doc)} />
                    </div>
                </Col>
                <Col span={24} className={
                    "d-flex flex-direction-row justify-content-space-between"
                }>
                    <div className={"doc-date"}>
                        {doc &&
                            moment(doc.modified_date).format(
                                "MMM Do YYYY,    h:mm a"
                            )}
                    </div>
                    <div className={"doc-date"}>
                        {doc && !doc.request_remarks ? (
                            <Button type={"link"} size={"small"} onClick={() => this.props.addRequestedRemark(doc.id, doc)}>{"Add Remark"}</Button>
                        ) : (
                            <React.Fragment>
                                <Icon size={"small"} type={"check-circle"} /> <span>Remark Added</span>
                            </React.Fragment>)
                        }
                    </div>
                </Col>
                {doc && doc.request_remarks ? (
                    <div className={"doc-date"}>
                        <Col span={20} style={{
                            color: "#eb5757"
                        }}>
                            {doc.request_remarks}
                        </Col>
                        <Col span={4}>
                            <Icon type={"edit"} onClick={() => this.props.addRequestedRemark(doc.id, doc)} />
                        </Col>
                    </div>
                ) : null}
            </React.Fragment>
        );
    }

    getStyle = _ => {
        if (this.state.isClicked === _.id) {
            return {
                background: "#e8fff1"
            };
        }
        return null;
    };

    isSelected = file => file && file.id === this.props.selectedFileId;

    selectFile = file => this.props.viewDoc(file);

    toggleUploadModal = () => {
        this.setState({
            showUploadModal: !this.state.showUploadModal
        });
    }

    submitForm = (values) => {
        try {
            let file = new FormData();
            // file.append("files", values.files);
            values.files.map(_ => {
                file.append("files", _);
            });
            message.loading("Uploading Documents");
            DocumentService.uploadBulkDocuments(this.props.companyId, file, values.document_type).then(_ => {
                this.props.uploadFiles(_.data && _.data.map(_ => ({ ..._, company: this.props.companyId })));
                message.success("Document Uploaded");
                this.toggleUploadModal();
            }).catch(() => {
                message.error("Failed to Upload Documents");
                this.toggleUploadModal();
            });
        } catch (err) {
            message.error("Failed to Upload Documents");
        }
    }

    render() {
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.showUploadModal}
                    footer={null}
                    closable={true}
                    onCancel={this.toggleUploadModal}
                    destroyOnClose
                    width={400}
                >
                    <div className={"p-5"}>
                        <UploadCompanyDoc
                            files={this.props.files}
                            onSubmit={this.submitForm}
                        />
                    </div>
                </Modal>
                <Card
                    className={"upload-btn document-view-list"}
                    style={{
                        minHeight: "90vh"
                    }}
                    title={"Documents List"}
                    extra={[
                        // eslint-disable-next-line react/jsx-key
                        <React.Fragment key={"requestParent"}>
                            {this.props.viewUploadButton && <Button key={"upload"} size={"small"} icon={"file-add"} onClick={this.props.toggleUploadModal}>
                                Upload More
                            </Button>}
                            {<Button key={"request"} size={"small"} style={{
                                marginLeft: "10px"
                            }} onClick={() => this.props.openRequestModal()}>
                                Request Document
                            </Button>}
                        </React.Fragment>
                    ]}
                >
                    <Row className={"doc-list-view"}>
                        <Col span={24} className={"mb-10"}>
                            <Input.Search
                                onChange={this.onDocSearch}
                                placeholder={"Type Document Name to search"}
                            />
                        </Col>
                        <Col span={24}>
                            {/* <Tabs size={"small"} className={"list-view"} activeKey={this.state.selectedTab} onChange={this.onTabChange}>
                                <TabPane tab="Uploaded Docs" key={"uploaded"}>
                                    <AntList grid={{ column: 1 }} loading={this._areFilesLoading}>
                                        {this.props.files.filter(_ => _.document_status !== DOCUMENT_CURRENT_STATUS.get("Requested"))
                                            .filter(this.docFilter)
                                            .sort((a, b) => {
                                                if(a.id > b.id) {
                                                    return -1;
                                                }
                                                if(a.id < b.id) {
                                                    return 1;
                                                }
                                                if(a.id === b.id) {
                                                    return 0;
                                                }
                                            })
                                            .map(_ => (
                                                <ListItem
                                                    className={cx("item-unclicked", {
                                                        ["clicked-item"]: this.isSelected(_)
                                                    })}
                                                    key={_.id}>

                                                    <Card
                                                        size={"small"}
                                                        title={this.getTitle(_)}
                                                        className={
                                                            "padless-card no-shadow w-100 doc-card file-actions"
                                                        }
                                                        actions={[
                                                            <Button 
                                                                size={"small"}
                                                                key={"download"}
                                                                type={"link"} 
                                                                icon={"download"} 
                                                                target={"_blank"} 
                                                                href={_.file} 
                                                            />,
                                                            <Popconfirm
                                                                key={"delete"}
                                                                title="Are you sure delete this file?"
                                                                onConfirm={
                                                                    () => this.props.deleteRequestedDocument(_.id,_)
                                                                }
                                                                okText="Yes"
                                                                cancelText="No"
                                                            >
                                                                <Button style={{
                                                                    cursor: "pointer",
                                                                    color: "#246079"
                                                                }} icon={"delete"} type={"link"} disabled={_.document_status === DOCUMENT_CURRENT_STATUS.get("Verified")} />
                                                            </Popconfirm>,
                                                            <Button 
                                                                key={"view"}
                                                                size={"small"} 
                                                                type={"link"}
                                                                style={{
                                                                    color: "#246079"
                                                                }}
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.selectFile(_);
                                                                }}
                                                            >View</Button> 
                                                        ]}
                                                    />
                                                </ListItem>
                                            ))
                                            .toArray()}
                                    </AntList>
                                </TabPane>
                                <TabPane tab={"Requested Docs"} key={"requested"}>
                                    <AntList grid={{ column: 1 }} loading={this._areFilesLoading}>
                                        {this.props.files.filter(_ => _.document_status === DOCUMENT_CURRENT_STATUS.get("Requested"))
                                            .filter(this.docFilter)
                                            .sort((a, b) => {
                                                if(a.id > b.id) {
                                                    return -1;
                                                }
                                                if(a.id < b.id) {
                                                    return 1;
                                                }
                                                if(a.id === b.id) {
                                                    return 0;
                                                }
                                            })
                                            .map(_ => (
                                                <ListItem
                                                    className={cx("item-unclicked", {
                                                        ["clicked-item"]: this.isSelected(_)
                                                    })}
                                                    key={_.id}>
                                                    <Card
                                                        // onClick={() => this.selectFile(_)}
                                                        size={"small"}
                                                        title={this.getRequestedDocTitle(_)}
                                                        className={
                                                            "padless-card no-shadow w-100 doc-card"
                                                        }
                                                    />
                                                </ListItem>
                                            ))
                                            .toArray()}
                                    </AntList>
                                </TabPane>
                            </Tabs>
                         */}

                            <Tabs size={"small"} className={"list-view"} activeKey={this.state.selectedTab} onChange={this.onTabChange}>
                                <TabPane tab="Uploaded Docs" key={"uploaded"}>
                                    <AntList
                                        grid={{ column: 1 }}
                                        // loading={this._areFilesLoading}
                                        loading={this.props.loading}
                                    >
                                        {/* {this.props.files.filter(_ => _.document_status !== DOCUMENT_CURRENT_STATUS.get("Requested")) */}
                                        {this.props.docFiles && this.props.docFiles.filter(el=>[2,3,4].includes(el.document_status))
                                            // .filter(this.docFilter)
                                            .sort((a, b) => {
                                                if (a.id > b.id) {
                                                    return -1;
                                                }
                                                if (a.id < b.id) {
                                                    return 1;
                                                }
                                                if (a.id === b.id) {
                                                    return 0;
                                                }
                                            })
                                            .map(_ => (
                                                <ListItem
                                                    className={cx("item-unclicked", {
                                                        ["clicked-item"]: this.isSelected(_)
                                                    })}
                                                    key={_.id}>

                                                    <Card
                                                        size={"small"}
                                                        title={this.getTitle(_)}
                                                        className={
                                                            "padless-card no-shadow w-100 doc-card file-actions"
                                                        }
                                                        actions={[
                                                            <Button
                                                                size={"small"}
                                                                key={"download"}
                                                                type={"link"}
                                                                icon={"download"}
                                                                target={"_blank"}
                                                                href={`${process.env.FILE_DOWNLOAD_URL}/${_.file}`}
                                                            />,
                                                            // <Popconfirm
                                                            //     key={"delete"}
                                                            //     title="Are you sure delete this file?"
                                                            //     onConfirm={
                                                            //         () => this.props.deleteRequestedDocument(_.id,_)
                                                            //     }
                                                            //     okText="Yes"
                                                            //     cancelText="No"
                                                            // >
                                                            //     <Button style={{
                                                            //         cursor: "pointer",
                                                            //         color: "#246079"
                                                            //     }} icon={"delete"} type={"link"} disabled={_.document_status === DOCUMENT_CURRENT_STATUS.get("Verified")} />
                                                            // </Popconfirm>,
                                                            <Button
                                                                key={"view"}
                                                                size={"small"}
                                                                type={"link"}
                                                                style={{
                                                                    color: "#246079"
                                                                }}
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.selectFile(_);
                                                                }}
                                                            >View</Button>
                                                        ]}
                                                    />
                                                </ListItem>
                                            ))
                                            .toArray()}
                                    </AntList>
                                </TabPane>
                                {this.props.isOnboardingCase && <TabPane tab={"Requested Docs"} key={"requested"}>
                                    <AntList grid={{ column: 1 }}>
                                        {this.props.files.filter(_ => _.document_status === DOCUMENT_CURRENT_STATUS.get("Requested"))
                                            .filter(this.docFilter)
                                            .sort((a, b) => {
                                                if (a.id > b.id) {
                                                    return -1;
                                                }
                                                if (a.id < b.id) {
                                                    return 1;
                                                }
                                                if (a.id === b.id) {
                                                    return 0;
                                                }
                                            })
                                            .map(_ => (
                                                <ListItem
                                                    className={cx("item-unclicked", {
                                                        ["clicked-item"]: this.isSelected(_)
                                                    })}
                                                    key={_.id}>
                                                    <Card
                                                        // onClick={() => this.selectFile(_)}
                                                        size={"small"}
                                                        title={this.getRequestedDocTitle(_)}
                                                        className={
                                                            "padless-card no-shadow w-100 doc-card"
                                                        }
                                                    />
                                                </ListItem>
                                            ))
                                            .toArray()}
                                    </AntList>
                                </TabPane>}
                            </Tabs>
                        </Col>
                    </Row>
                </Card>
            </React.Fragment>
        );
    }
}
CompanyDocumentViewList.propTypes = {
    companyId: PropTypes.number,
    files: PropTypes.object,
    selectedFileId: PropTypes.number,
    uploads: PropTypes.object,
    docFiles: PropTypes.object,
    uploadFiles: PropTypes.func,
    invalidateDocument: PropTypes.func,
    viewDoc: PropTypes.func,
    changeName: PropTypes.func,
    isUserAllowedToEdit: PropTypes.bool,
    editDocumentAttached: PropTypes.bool,
    openRequestModal: PropTypes.func,
    docMasterList: PropTypes.array,
    docMasterListStatus: PropTypes.string,
    deleteRequestedDocument: PropTypes.func,
    filesStatus: PropTypes.string,
    filter: PropTypes.string,
    loading: PropTypes.bool,
    addRequestedRemark: PropTypes.func,
    toggleUploadModal: PropTypes.func
};

export default CompanyDocumentViewList;
